/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceAuditProblemConfidence {
  High = "high",
  Medium = "medium",
  Low = "low",
}

export function instanceOfInvoiceAuditProblemConfidence(value: any): boolean {
  for (const key in InvoiceAuditProblemConfidence) {
    if (
      Object.prototype.hasOwnProperty.call(InvoiceAuditProblemConfidence, key)
    ) {
      if (
        InvoiceAuditProblemConfidence[
          key as keyof typeof InvoiceAuditProblemConfidence
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceAuditProblemConfidenceFromJSON(
  json: any,
): InvoiceAuditProblemConfidence {
  return InvoiceAuditProblemConfidenceFromJSONTyped(json, false);
}

export function InvoiceAuditProblemConfidenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemConfidence {
  return json as InvoiceAuditProblemConfidence;
}

export function InvoiceAuditProblemConfidenceToJSON(
  value?: InvoiceAuditProblemConfidence | null,
): any {
  return value as any;
}

export function InvoiceAuditProblemConfidenceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemConfidence {
  return value as InvoiceAuditProblemConfidence;
}
